import { Languages } from "../lang";

function getIsTomorrow(fixture: Date) {
  const date = new Date();
  date.setDate(date.getDate() + 1);
  const tomorrow = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();
  if (
    tomorrow === fixture.getDate() &&
    month === fixture.getMonth() &&
    year === fixture.getFullYear()
  )
    return true;
  return false;
}

function getIsToday(fixture: Date) {
  const day = new Date().getDate();
  const month = new Date().getMonth();
  const year = new Date().getFullYear();

  const fixtureDay = fixture.getDate();
  const fixtureMonth = fixture.getMonth();
  const fixtureYear = fixture.getFullYear();

  if (day === fixtureDay && month === fixtureMonth && year === fixtureYear) {
    return true;
  }

  return false;
}

function getTomorrow() {
  const lang = Languages[window.navigator.language.toLowerCase()];
  return lang?.DateTimeTexts?.Tomorrow || "Tomorrow";
}

function getToday() {
  const lang = Languages[window.navigator.language.toLowerCase()];
  return lang?.DateTimeTexts?.Today || "Today";
}

function getTimeTillNextWeek(): number {
  const today = new Date(Date.now()); // passing Date.now() as its easier to mock
  const nextweek = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() + 6
  );
  return nextweek.valueOf() - today.valueOf();
}

function getTimeTillFixture(fixture: Date): number {
  const today = new Date(Date.now()); // passing Date.now() as its easier to mock
  return fixture.valueOf() - today.valueOf();
}

export default function(fixture: string, languageCode: string): string {
  const dateFixture = new Date(fixture);
  const timeTillFixture = getTimeTillFixture(dateFixture);
  const timeTillNextWeek = getTimeTillNextWeek();
  const isToday = getIsToday(dateFixture);
  const isTomorrow = getIsTomorrow(dateFixture);

  if (isToday) {
    const formattedDate = dateFixture.toLocaleTimeString(languageCode, {
      hour: "numeric",
      minute: "2-digit"
    });
    return `${getToday()}, ${formattedDate}`;
  }

  if (isTomorrow) {
    const formattedDate = dateFixture.toLocaleTimeString(languageCode, {
      hour: "numeric",
      minute: "2-digit"
    });
    return `${getTomorrow()}, ${formattedDate}`;
  }

  // fixture is in the future but less that 6 days away
  if (timeTillFixture > 0 && timeTillFixture < timeTillNextWeek) {
    const formattedDate = dateFixture.toLocaleTimeString(languageCode, {
      weekday: "short",
      hour: "numeric",
      minute: "2-digit"
    });
    return formattedDate;
  }

  const formattedDate = dateFixture.toLocaleDateString(languageCode, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit"
  });

  return formattedDate;
}
